// source: SignatureAuthenticationType.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.Billon.SignatureAuthenticationType.SignatureAuthenticationType', null, global);
/**
 * @enum {number}
 */
proto.Billon.SignatureAuthenticationType.SignatureAuthenticationType = {
  UNDEFINED: 0,
  SMS: 1,
  TWO_FACTOR: 2,
  PASSWORD: 3,
  BIOMETRICS: 4
};

goog.object.extend(exports, proto.Billon.SignatureAuthenticationType);
